// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__djx7j","label":"Contact_label__bnwOh","field":"Contact_field__pha7j","button":"Contact_button__xNnud"};